module.exports = __webpack_public_path__ + "static/img/logo_dgcp.ffb1a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_dgcp.png
// module id = FILb
// module chunks = 0